import React from "react"
import {
    UploadQueueItem,
    UploadStatus
} from "../../../../../../../Models/Client/UploadQueueItem"
import { Text, Button } from "dash-styled"
import { ReactComponent as IconClose } from "icons/lib/close-icon.svg"
import { SimpleInfoBox } from "../../../../../SimpleInfoBox/SimpleInfoBox"
import { LinkButton } from "../../../../../LinkButton/LinkButton"
import { ReactComponent as IconSpinner } from "icons/lib/spinner.svg"
import { Thumbnail } from "../../../../../Thumbnail/Thumbnail"
import { FileType } from "../../../../../../../Models/Client/FileType"

interface UploadableRowProps {
    item: UploadQueueItem
    type?: FileType
    onRemove: () => void
    onRetry: () => void
}

export function UploadableRow({
    type,
    item,
    onRemove,
    onRetry
}: UploadableRowProps) {
    const itemType =
        type === "imageAndDocument" && item.status === UploadStatus.Finished
            ? item.url.toLowerCase().includes(".pdf")
                ? "document"
                : "image"
            : type

    return (
        <div className="-mb-px border-0 border-t border-b border-solid border-gray-300 py-3">
            <div className="flex items-center justify-between">
                {item.status === UploadStatus.InProgress ||
                item.status === UploadStatus.Queued ? (
                    <IconSpinner className="w-12 h-12 border border-solid border-smoke-200 p-2 flex-shrink-0" />
                ) : (
                    <Thumbnail
                        type={itemType}
                        value={item.objectUrl}
                        className="flex-shrink-0"
                    />
                )}
                <Text className="flex-grow flex-shrink truncate ml-4">
                    {item.name}
                </Text>
                <Button
                    variant="text"
                    color="gray"
                    onClick={onRemove}
                    className="flex-grow-0 w-auto px-4"
                >
                    <IconClose className="p-0.5 w-5 h-5" />
                </Button>
            </div>
            {item.status === UploadStatus.Failed && (
                <SimpleInfoBox variant="alert" className="mt-4">
                    <div className="w-full flex items-center justify-between">
                        Upload failed: {item.reason}
                        <LinkButton
                            className="w-auto ml-3 text-sm"
                            onClick={onRetry}
                        >
                            Retry
                        </LinkButton>
                    </div>
                </SimpleInfoBox>
            )}
        </div>
    )
}
